class AnchorScroll {
    constructor() {
        document.querySelectorAll('a[href^="#"]').forEach(el => {
            this.init(el)
        })
    }

    init(item) {
        item.addEventListener('click', (e) => {
            let anchor = item.getAttribute('href')
            let target = document.querySelector(anchor)
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            })
            history.pushState(null, null, anchor)
            e.preventDefault()
        })
    }
}

export default AnchorScroll
